import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-query-risque-professionnel-dangereux',
  templateUrl: './query-risque-professionnel-dangereux.component.html',
  styleUrls: ['./query-risque-professionnel-dangereux.component.scss']
})
export class QueryRisqueProfessionnelDangereuxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
